import { render, staticRenderFns } from "./FeatureTwo.vue?vue&type=template&id=32788899&"
import script from "./FeatureTwo.vue?vue&type=script&lang=js&"
export * from "./FeatureTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports